// src/lib/editorUtils.js
// Utilitaires partagés par MenuPageEditor et GoogleReviewPageEditor.
import { useRef, useState } from 'react'
import api from './axios'

/** "Mon Café !" -> "mon-cafe" */
export function slugify(value = '') {
  return value
    .toString()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .slice(0, 60)
}

/** Déplace un élément d'un tableau (sans muter). */
export function moveItem(list, index, direction) {
  const target = index + direction
  if (target < 0 || target >= list.length) return list
  const copy = [...list]
  ;[copy[index], copy[target]] = [copy[target], copy[index]]
  return copy
}

/** Extrait un message lisible d'une erreur axios. */
export function getApiError(err, fallback = 'Erreur lors de la sauvegarde.') {
  const data = err?.response?.data
  return (
    data?.error ||
    data?.message ||
    (data?.errors ? Object.values(data.errors).flat().join(' • ') : '') ||
    err?.message ||
    fallback
  )
}

/** Upload d'une image via /upload et renvoie l'URL. */
export async function uploadImage(file, type = 'image') {
  const formData = new FormData()
  formData.append('file', file)
  formData.append('type', type)
  const { data } = await api.post('/upload', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  })
  return data.url
}

/**
 * Détecte les modifications non enregistrées.
 * - `isReady` : passer true quand l'état initial est chargé.
 * - `markSaved()` : à appeler après une sauvegarde réussie.
 */
export function useDirtyTracker(value, isReady) {
  const snapshot = useRef(null)
  const latest = useRef('')
  const [, force] = useState(0)

  latest.current = JSON.stringify(value)
  if (isReady && snapshot.current === null) snapshot.current = latest.current

  const markSaved = () => {
    snapshot.current = latest.current
    force((n) => n + 1)
  }

  return {
    isDirty: snapshot.current !== null && snapshot.current !== latest.current,
    markSaved,
  }
}